import { useMemo } from "react"
import { FetchState, hasValue } from "../Models/Client/FetchState"
import { Result } from "../Models/Utility/Result"

export function useFetchState<S1, T>(
    fetch1: FetchState<S1>,
    map: (value: S1) => T
): FetchState<T>
export function useFetchState<S1, S2, T>(
    fetch1: FetchState<S1>,
    fetch2: FetchState<S2>,
    map: (value1: S1, value2: S2) => T
): FetchState<T>
export function useFetchState<S1, S2, S3, T>(
    fetch1: FetchState<S1>,
    fetch2: FetchState<S2>,
    fetch3: FetchState<S3>,
    map: (value1: S1, value2: S2, value3: S3) => T
): FetchState<T>
export function useFetchState<S1, S2, S3, S4, T>(
    fetch1: FetchState<S1>,
    fetch2: FetchState<S2>,
    fetch3: FetchState<S3>,
    fetch4: FetchState<S4>,
    map: (value1: S1, value2: S2, value3: S3, value4: S4) => T
): FetchState<T>
export function useFetchState<S, T>(
    ...args: [...FetchState<S>[], (...value: S[]) => T]
): FetchState<T> {
    const map = args[args.length - 1] as (...value: S[]) => T
    const fetches = args.slice(0, args.length - 1) as FetchState<S>[]

    return useMemo(
        () => {
            const values: S[] = []
            for (const fetchState of fetches) {
                if (!hasValue(fetchState)) {
                    return fetchState
                }

                values.push(fetchState.value)
            }

            return Result.ok(map(...values))
        }, // eslint-disable-next-line react-hooks/exhaustive-deps
        [JSON.stringify(fetches), map]
    )
}
